var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-button"},[_c('el-button',{class:{ 'x-flex x-row-center': _vm.loading, 'x-disabled': _vm.disabled },style:({
    'background-color': _vm.bgc,
    'color': _vm.color,
    'border': _vm.border,
    'min-width': _vm.width,
    'margin-left': _vm.margin_left,
    'margin-right': _vm.margin_right
  }),attrs:{"size":_vm.size,"loading":_vm.loading,"disabled":_vm.disabled}},[_c('div',{staticClass:"x-p-l-10 x-p-r-10"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a6ea10c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xButton.vue
// module id = null
// module chunks = 